import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AdminServiceService } from '../../service/admin-service.service';
import { environment } from 'src/environments/environment';
import { ModalShopsComponent } from '../modal-shops/modal-shops.component';
import { ToastService } from 'src/app/generales/services/toast.service';

@Component({
  selector: 'app-certificate',
  templateUrl: './certificate.component.html',
  styleUrls: ['./certificate.component.scss'],
})
export class CertificateComponent implements OnInit {
  data: any;
  pag = 1;
  pagSyze = 10;
  search = 'todos';
  date = 'mas-recientes';
  state = '';
  lastPage: number;
  total: number;
  url: string = environment.url;
  title = "Certificados";
  constructor(
    private req: AdminServiceService,
    private modalCtrl: ModalController,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.loadData();
  }
  async loadData() {
    this.req.getCertify().subscribe((res: any) => {
      this.data = res.data;
      console.log(this.data);
      
    });
  }
  async goModal(i) {
    this.req.showShop(i).subscribe(async (res: any) => {
      const m = res.data;
      const modal = await this.modalCtrl.create({
        component: ModalShopsComponent,
        cssClass: 'modal-blog-comentarios',
        componentProps: {shop: m},
      });
      modal.present();
    });
  }
  async goModalUser(i) {
    this.req.showUser(i).subscribe(async (res: any) => {
      const m = res.data;
      const modal = await this.modalCtrl.create({
        component: ModalShopsComponent,
        cssClass: 'modal-blog-comentarios',
        componentProps: {shop: m},
      });
      modal.present();
    });
  }
  async goModalPay(i) {
    this.req.showPay(i).subscribe(async (res: any) => {
      const m = res.data;
      const modal = await this.modalCtrl.create({
        component: ModalShopsComponent,
        cssClass: 'modal-blog-comentarios',
        componentProps: {shop: m, pay: true},
      });
      modal.present();
    });
  }
  async certificar(m, ev) {
    const data = {
      id: m,
      state: ev.detail.value
    };
    this.req.certificate(data).subscribe((res) => {
      this.toastService.show(
        'Se ha actualizado el estado'
      );
    });
  }
}
